<template>
    <div
        class="!p-0 w-full flex justify-center at1024:justify-start items-start flex-row-reverse"
    >
        <span v-if="externalNav" class="w-80 p-8 shrink-0 hidden at1024:block app-scrollbar">
            <SeclockMultiselect
                class="mt-2 mb-8"
                :options="manufacturers?.filter((manufacturer) => manufacturer.logo)?.map((manufacturer) => ({'label': manufacturer.name,'value': manufacturer.slug}))"
                :placeholder="$t('Select A Manufacturer')"
                :searchable="true"
                :can-clear="false"
                :large="true"
                @change="navigateToShow($event)"
            />
            <span class="block w-full type-secondary font-medium pb-4 bg-gray-tier-3">
                {{ $t("Browse by category") }}
            </span>
            <SideNav
                class="w-full"
                :sections="tags"
                :click-to-scroll="false"
                :all="true"
                v-model="selectedTag"
            />
        </span>
        <div class="grow p-8 pr-0 overflow-hidden at1024:overflow-visible">
            <div class="flex items-center justify-between mb-8">
                <div v-if="!query.tag" class="shrink overflow-x-auto">
                    <AlphabetFilter v-model="query.letter" :available-letters="availableLetters"/>
                </div>
                <div v-else class="w-full p-3 bg-gray-tier-4 rounded border border-gray-tier-6">
                    {{ $t("Category") }}:
                    <span class="font-bold">{{ selectedTag.name }}</span>
                    <button
                        class="type-secondary hover:type-primary ml-6 underline underline-offset-4"
                        @click="selectedTag = null"
                    >
                        {{ $t("Clear") }}
                    </button>
                </div>
                <div class="pl-4 border-l at1440:border-l-0 border-gray-tier-6 w-auto flex items-center gap-2 fill-gray-500">
                    <button @click.prevent="displaySetting = 'grid'">
                        <span>
                            <BaseSvg
                                name="icon-grid-view"
                                :class="
                                    displaySetting === 'grid'
                                        ? 'opacity-100'
                                        : 'opacity-25 at1024:hover:opacity-50'
                                "
                                class="duration-75 w-8 type-primary"
                            />
                        </span>
                    </button>
                    <button @click.prevent="displaySetting = 'rows'">
                        <span>
                            <BaseSvg
                                name="icon-list"
                                :class="
                                    displaySetting === 'rows'
                                        ? 'opacity-100'
                                        : 'opacity-25 at1024:hover:opacity-50'
                                "
                                class="duration-75 w-8 type-primary"
                            />
                        </span>
                    </button>
                </div>
            </div>
            <ul
                class="w-full"
                :class="
                    displaySetting === 'grid'
                        ? 'grid gap-4 grid-cols-1 at768:grid-cols-2 at1200:grid-cols-3'
                        : ''
                "
            >
                <template v-for="manufacturer in filteredManufacturers">
                <li v-if="marketingAssetUrl(manufacturer.logo?.external_id)">
                    <ManufacturerCard
                        :manufacturer="manufacturer"
                        :display-setting="displaySetting"
                    />
                </li>
                </template>
            </ul>
        </div>
    </div>
</template>

<script setup>
import {
    AlphabetFilter,
    BaseSvg,
    ManufacturerCard, SeclockMultiselect,
    SideNav,
} from "@/Components";
import {computed, inject, reactive, ref, watch} from "vue";
import {useAssetTransforms} from "@/Composables";
import {router, usePage} from "@inertiajs/vue3";
const { marketingAssetUrl } = useAssetTransforms();
const props = defineProps(["manufacturers", "tags", "availableLetters", 'externalNav']);


const displaySetting = ref("grid");
const route = inject("route");

const query = reactive(usePage().props.query ?? {});

const selectedTag = computed({
    get: () => {
        return props.tags.find((tag) => tag.name === query.tag);
    },
    set: (tag) => {
        query.tag = tag;
        if(tag){
            query.letter = null;
        }
    },
});

watch(query, (newQuery) => {
    router.get(route(route().current()),
        query,
        {
            replace: true,
            preserveScroll: true,
            preserveState: true,
            preserveQuery: false,
            only: ["referer", "query","flash"],
        }
    );
});

const filteredManufacturers = computed(() => {
    let data = props.manufacturers;

    if (selectedTag.value) {
        return data.filter((manufacturer) =>
            manufacturer.tag_ids?.includes(selectedTag.value.id)
        );
    }

    if (query.letter) {
        return data.filter((manufacturer) =>
            manufacturer.name?.startsWith(query.letter.toLowerCase()) || manufacturer.name?.startsWith(query.letter.toUpperCase())
        );
    }

    return data;
});

const navigateToShow = (slug) => {
    router.visit(route('web.catalog.manufacturers.show', slug))
};
</script>
